export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/hr.lyaml"));
at({ "hr": { "public": { "sampleString": "Ogledni niz" } } });
};